module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-6.f26ab066.jpg";